webpackJsonp([173],{

/***/ 1182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "担心停止维护 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1997:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1182),
  /* template */
  __webpack_require__(2104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/will-vux-stop-maintaining-27.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] will-vux-stop-maintaining-27.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-29559042", Component.options)
  } else {
    hotAPI.reload("data-v-29559042", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2104:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("担心停止维护")]), _vm._v(" "), _c('p', [_vm._v("一个项目会停止维护主要原因是社区不活跃，用户量不够多，而且没有人愿意贡献。")]), _vm._v(" "), _c('p', [_vm._v("VUX 和 Vue 一样正在发展中，越多越多的开发者在使用，在可预见的时间内不会突然停止维护。")]), _vm._v(" "), _c('p', [_vm._v("希望大家能帮助完善文档，完善代码，帮助项目发展。")]), _vm._v(" "), _c('p', [_vm._v("能贡献代码的贡献代码，"), _c('del', [_vm._v("不能贡献代码直接用钱也可以 😃")]), _vm._v(" 。")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29559042", module.exports)
  }
}

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1997);

/***/ })

});


// WEBPACK FOOTER //
// 173.8f5d29b5.js